/**
 * ShimmerTrackCard - Loading placeholder for TrackCard
 * Shows animated shimmer effect while tracks are loading
 */
const ShimmerTrackCard = () => {
  return (
    <div className="bg-[#111] border border-[#F2D857]/20 rounded-lg p-6 animate-pulse">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-4 flex-1">
          {/* Shimmer circle for play button/artwork */}
          <div className="w-16 h-16 bg-[#222] rounded"></div>
          
          {/* Shimmer text lines */}
          <div className="flex-1 space-y-2">
            <div className="h-6 bg-[#222] rounded w-2/3"></div>
            <div className="h-4 bg-[#222] rounded w-1/2"></div>
            <div className="h-3 bg-[#222] rounded w-1/3"></div>
          </div>
        </div>
        
        {/* Shimmer action buttons */}
        <div className="flex gap-2">
          <div className="w-10 h-10 bg-[#222] rounded"></div>
          <div className="w-10 h-10 bg-[#222] rounded"></div>
          <div className="w-10 h-10 bg-[#222] rounded"></div>
        </div>
      </div>
    </div>
  );
};

export default ShimmerTrackCard;
